module.exports = __webpack_public_path__ + "static/5-Building-f9a5a295477576ee4ccafcd5d7bd7a0d.png";